import {type PropsWithChildren, useCallback} from 'react'
import {FiltersContext} from './FiltersContext'
import {ProjectId} from '@package/shared'
import {useSearchParams} from 'react-router-dom'
import dayjs from 'dayjs'
import {formatIsoMonth} from '../../formatter/formatIsoMonth.ts'
import type {DateRange} from '../../../../components/dateRangeSelector/DateRangeSelector.tsx'

export const FiltersProvider = ({children}: PropsWithChildren) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const startParam = searchParams.get('start') || undefined
  const month: DateRange = {
    start: dayjs(startParam).startOf('month'),
    end: dayjs(startParam).endOf('month'),
  }
  const projectId = searchParams.has('project') ? ProjectId.parse(searchParams.get('project')) : null

  const handleSetProjectId = useCallback(
    (projectId: ProjectId | null) => {
      setSearchParams((searchParams) => {
        if (projectId) searchParams.set('project', projectId)
        else searchParams.delete('project')

        return searchParams
      })
    },
    [setSearchParams],
  )

  const handleSetMonth = useCallback(
    (month: DateRange) => {
      setSearchParams((searchParams) => {
        if (month.start.isSame(dayjs().startOf('month'))) searchParams.delete('start')
        else searchParams.set('start', formatIsoMonth(month.start))
        return searchParams
      })
    },
    [setSearchParams],
  )

  return (
    <FiltersContext.Provider
      value={{
        projectId,
        setProjectId: handleSetProjectId,
        month,
        setMonth: handleSetMonth,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}
